// export default Blog;





import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useBlogStore } from "../../store/blog-store";
import { useBlogInitializer } from "../../hooks/useBlogInitializer";

const Blog = () => {
  useBlogInitializer();
  const blogs = useBlogStore((s) => s.blogs);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const extract = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || "";
  };

  if (!blogs.length)
    return <div className="text-center mt-20">Loading blogs...</div>;

  return (
    <div className="max-w-7xl mx-auto px-4 py-10">

      <h1 className="text-4xl font-bold text-center mb-10 uppercase">
        All Blogs
      </h1>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

        {blogs.map((blog) => (
          <div
            key={blog.id}
            onClick={() => navigate(`/blogs/${blog.id}`)}
            className="cursor-pointer rounded-xl overflow-hidden shadow hover:shadow-xl transition"
          >
            <img
              src={blog.image}
              alt=""
              className="h-56 w-full object-cover"
            />

            <div className="p-5">
              <h2 className="font-bold text-lg mb-2">
                {extract(blog.title)}
              </h2>

              <p className="text-gray-600 text-sm line-clamp-3">
                {extract(blog.paragraph)}
              </p>

              <button className="mt-4 text-primary group-hover:text-primary-dark transition-colors text-sm font-bold uppercase tracking-wide">
                Read More →
              </button>
            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default Blog;
